<template>
    <div>
        <PayAlert :isShow="isShow" @increase="getAlertState"/>
        <ContentHeader :disabled="false" :title="lang('singleLeftMenuText1_4',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin size="large" fix v-if="tchJobListLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleJobTitle',language)}}
            </p>
            <Row>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleTchJobTipTitle1',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{readJobsCnt}}
                        <span :style="{fontSize:'18px'}">{{lang('singleJobText1',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleTchJobTipTitle2',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{completedReadJobRate*100 | numFilter}}%
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleTchJobTipTitle3',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'16px',fontWeight:'bold'}">
                        {{lang('singleJobText2',language)}}
                        {{readJobTypeRatio.readOnlyRatio * 100 | numFilter}}%，
                        {{lang('singleJobText4',language)}}
                        {{readJobTypeRatio.retellOnlyRatio * 100 | numFilter}}%,
                        {{lang('singleJobText6',language)}}
                        {{readJobTypeRatio.bothRatio * 100 | numFilter}}%
                    </p>
                </Col>
                <Col span="6">
                    <p :style="{color: '#4F6B87'}">{{lang('singleTchJobTipTitle4',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'16px',fontWeight:'bold'}">
                        <span>
                            {{lang('singleTchJobText1',language)}}{{classAndGroupCnt.classes}}
                            <span :style="{fontSize:'18px'}">{{lang('singleTchJobText5',language)}}</span>
                        </span>
                        ,
                        <span>
                            {{lang('singleTchJobText3',language)}}{{classAndGroupCnt.groups}}
                            <span :style="{fontSize:'18px'}">{{lang('singleTchJobText5',language)}}</span>
                        </span>
                    </p>
                </Col>
            </Row>
        </Card>
        <br/>

        <Row>
            <Col span="24">
                <SelectDate @increase="getDateRange"/>
                <Card>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{lang('singleJobText5',language)}}
                    </p>
                    <Button slot="extra" type="primary" @click="exportData">
                        <Icon type="ios-download-outline"></Icon>
                        {{lang('exportText',language)}}
                    </Button>
                    <Row>
                        <div v-for="(item,index) in jobList" :key="index">
                            <Card>
                                <p slot="title" :style="{textAlign:'left'}">
                                    <Icon type="ios-people" size="20"></Icon>
                                    {{item.targetName}}（{{item.students}}{{lang('singleTchJobText7',language)}}）

                                </p>
                                <div slot="extra">
                                    {{item.effectiveTime}}
                                    ~
                                    {{item.ineffectiveTime}}
                                </div>
                                <Row v-for="job in item.books" :key="job">
                                    <Row :gutter="32">
                                        <Col span="4">
                                            <p :style="{textAlign:'left',fontWeight:'bold'}">
                                                {{job.jobDesc}}{{job.bookName}}
                                            </p>
                                        </Col>
                                        <Col span="10">
                                            <p :style="{textAlign:'left'}">
                                                <span :style="{fontWeight:'bold'}">
                                                    {{lang('singleTchJobText9',language).replace('@',job.rjbDetail.completeReadUsers.length)}}
                                                </span><span v-if="job.rjbDetail.completeReadUsers.length>0">：</span>
                                                <span v-for="(stu,index) in job.rjbDetail.completeReadUsers" :key="index">
                                                        {{stu.nickname}}
                                                        <span v-if="index !== job.rjbDetail.completeReadUsers.length-1">，</span>
                                                </span>
                                            </p>
                                        </Col>
                                        <Col span="10">
                                            <p :style="{textAlign:'left'}">
                                                <span :style="{fontWeight:'bold'}">
                                                    {{lang('singleTchJobText11',language).replace('@',job.rjbDetail.incompleteReadUsers.length)}}
                                                </span><span v-if="job.rjbDetail.incompleteReadUsers.length>0">：</span>
                                                <span v-for="(stu,index) in job.rjbDetail.incompleteReadUsers" :key="index">
                                                        {{stu.nickname}}
                                                         <span v-if="index !== job.rjbDetail.incompleteReadUsers.length-1">，</span>
                                                </span>
                                            </p>
                                        </Col>
                                    </Row>
                                    <Divider/>
                                </Row>
                            </Card>
                            <br>
                        </div>

                    </Row>
                    <br>
                    <Page :total="total" show-sizer show-total show-elevator @on-change="changePage"
                          :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                          @on-page-size-change="changePageSize" placement="top" width="" v-if="jobList !== null && jobList.length>0"/>

                </Card>
            </Col>
        </Row>

    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import {formatDate} from '@/utils/common.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import {getSingleData,getSingleArgs} from '@/utils/net.js';
    import SelectDate from '@/components/SelectDate.vue';
    import PayAlert from '@/components/PayAlert.vue';

    export default {
        name: 'TeacherJob',
        store,
        components: {
            ContentHeader,
            SelectDate,
            PayAlert
        },
        data() {
            return {
                isShow:false,
                formatDate: formatDate,
                imgUrl: {
                    finish: require('@/assets/finish.png'),
                },
                lang: lang,
                stateLang: '',
                headerTipArr: [],
                tchJobListLoading: false,
                userId: '',
                readJobsCnt: '',
                completedReadJobRate: '',
                readJobTypeRatio: {},
                classAndGroupCnt: {},
                start: '',
                end: '',
                total: 0,
                page: 1,
                pageSize: 10,
                jobList: [],
                currentTimeTamp: Date.parse(new Date())
            }
        },
        mounted() {
            this.loadHeaderTipArr();

        },
        methods: {
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                for (var i = 1; i <= 4; i++) {
                    var item = {};
                    item.title = this.lang('singleStuJobTipTitle' + i, this.language);
                    item.content = this.lang('singleStuJobTipContent' + i, this.language);
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },

            getTchJobList() {
                let that = this;
                that.tchJobListLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/reading/rjob/list/tch',
                    params: {
                        start: that.start,
                        end: that.end,
                        page: that.page,
                        pageSize: that.pageSize,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.readJobsCnt = retMap.primary.readJobsCnt;
                        that.completedReadJobRate = retMap.primary.completedReadJobRate;
                        that.readJobTypeRatio = retMap.primary.readJobTypeRatio;
                        that.classAndGroupCnt = retMap.primary.classAndGroupCnt;
                        that.total = retMap.total;
                        that.jobList = retMap.list;
                        that.tchJobListLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.tchJobListLoading = false;
                    }
                })
            },

            getDateRange(data) {
                this.start = data.t2;
                this.end = data.t1;
                this.getTchJobList();
            },
            changePage(page) {
                this.page = page;
                this.getTchJobList();
            },
            changePageSize(pageSize) {
                this.pageSize = pageSize;
                this.getTchJobList();
            },


            getAlertState(data){
                this.isShow = data
            },

            exportData(){
                if(this.userInfo.isSvip){
                    let that = this;
                    let path = getSingleArgs({
                        context: that,
                        url: '/open/reading/rjob/list/tch/export',
                        params: {
                            start: that.start,
                            end: that.end,
                            de: config.de,
                        }
                    })
                    let a = document.createElement("a");
                    a.setAttribute("href", path);
                    a.setAttribute("target", "_blank");
                    a.click();
                }else{
                    this.isShow = true;
                }
            }

        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },
        watch: {
            stateLang: function () {

            }
        },
        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }

    }
</script>

<style scoped>
    .bookWrapper {
        float: left;
        width: 120px;
        height: 140px;
        text-align: center;
    }

    .bookCover {
        width: 100px;
        height: 120px;
        border-radius: 5px;
    }

</style>